import api from '@/api';

import { defaultSettings } from '../../common/config';

export default {
  namespaced: true,
  state: {
    loggedIn: false,
    details: null,
  },
  actions: {
    async register({ commit }, payload) {
      const { email, password, agreedToTos } = payload;
      const user = await api.auth.register(email, password);
      /**
       * We create separate user document in firestore because firebase auth
       * does not allow us to set custom fields on the user object
       */
      try {

        await api.auth.createUserDocument(user.uid, {
          // add extra field to mark it as a web registration
          email: email,
          settings: defaultSettings,
          agreedToTos: agreedToTos,
          createdFromImport: false,
        });
      } catch (error) {
        /**
         * If anything goes wrong here we need to delete the user created in previous step
         * to avoid polluting database
         */
        await api.auth.deleteUser();
        throw error;
      }

      commit('register', user);
    },
    async logIn({ commit }, payload) {
      const { email, password } = payload;
      const user = await api.auth.logIn(email, password);
      const { settings, ...rest } = await api.auth.getUser();
      commit('logIn', { ...user, ...rest });
      commit('estimate/getSettings', settings, { root: true });
    },
    logOut({ commit }) {
      return api.auth.logOut().then(() => {
        commit('logOut');
        commit('estimate/clearState', null, { root: true });
      });
    },
    sessionActive({ commit }, payload) {
      return api.auth.getUser().then((userDocument) => {
        const { settings, ...rest } = userDocument;
        commit('estimate/getSettings', settings, { root: true });
        commit('sessionActive', { ...payload, ...rest });
      });
    },
    deleteSubscription({ commit }) {
      return api.subscription.delete().then(() => {
        commit('deleteSubscription');
      });
    },
  },
  mutations: {
    register(state, payload) {
      state.loggedIn = true;
      state.details = payload;
    },
    logIn(state, payload) {
      state.loggedIn = true;
      state.details = payload;
    },
    logOut(state) {
      state.loggedIn = false;
      state.details = null;
    },
    sessionActive(state, payload) {
      state.loggedIn = true;
      state.details = payload;
    },
    userEmailVerified(state) {
      state.details.emailVerified = true;
    },
    deleteSubscription(state) {
      state.details = {
        ...state.details,
        cancelSubscriptionAtPeriodEnd: true,
      };
    },
  },
};
